<template>
  <div class="robot">
    <section class="top-wrap">
      <div class="main-title">群机器人</div>
      <div class="right">
        <div class="mRight10">
          <el-input
            v-model="searchText"
            size="small"
            placeholder="搜索机器人名称"
            clearable
            @keyup.native.enter="search"
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
        <el-button type="primary" size="small" @click="showCreate">新建</el-button>
      </div>
    </section>
    <section class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <base-table
        v-else
        ref="BaseTable"
        :tableHeight="tableHeight"
        :table-data="filterData"
        :table-columns="RobotTableColumns"
        :page-info="pageInfo"
        from="app"
      >
        <template v-slot:table-suffix>
          <el-table-column prop="handle" label="操作" align="center" width="160">
            <template v-slot="scope">
              <base-button @click="edit(scope.row)" class="base-button" type="text" size="mini">
                编辑
              </base-button>
              <base-button
                @click="deleteRobot(scope.row)"
                class="base-button"
                type="text"
                size="mini"
              >
                删除
              </base-button>
            </template>
          </el-table-column>
        </template>
      </base-table>
    </section>
    <save-ding-group-dialog
      ref="saveDingGroupDialog"
      :create="create"
      @change="refresh"
    ></save-ding-group-dialog>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import BaseButton from "@/components/UIComponents/Button"
import { RobotTableColumns } from "./static"
import TableController from "@/views/Backend/Admin/Layout/mixin/TableController"
import { getDingGroupList, deleteDingGroup } from "@/api/dingGroup"
import SaveDingGroupDialog from "./saveDingGroupDialog"

export default {
  name: "admin-app-robot",
  components: { BaseTable, BaseButton, SaveDingGroupDialog },
  inject: ["app"],
  data() {
    return {
      filterData: [],
      ruleList: [],
      filterKeys: ["name"],
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      },
      RobotTableColumns,
      create: true,
      searchText: ""
    }
  },
  mixins: [TableController],
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      getDingGroupList(this.app.id).then(group => {
        this.ruleList = group
        this.filterData = group
        this.resetPageInfo(this.filterData)
      })
    },
    search() {
      this.handleSearch({
        tableData: this.ruleList,
        filterKeys: this.filterKeys,
        searchText: this.searchText
      })
    },
    showCreate() {
      this.create = true
      this.$refs.saveDingGroupDialog.open("")
    },
    edit(row) {
      this.create = false
      this.$refs.saveDingGroupDialog.open(row)
    },
    deleteRobot(row) {
      deleteDingGroup(row.id).then(res => {
        this.$message.success("操作成功")
        this.refresh()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.robot {
  .base-button {
    font-size: 12px;
  }
}
</style>
